import React, { Children, Component } from 'react';
import { motion } from 'framer-motion';
interface AnimatedTextProps {
  text: string;
  className?: string;
  as?: React.ElementType;
}
export function AnimatedText({
  text,
  className = '',
  as: Component = 'h2'
}: AnimatedTextProps) {
  // Split text into words
  const words = text.split(' ');
  // Animation variants for container
  const container = {
    hidden: {
      opacity: 0
    },
    visible: (i = 1) => ({
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.04 * i
      }
    })
  };
  // Animation variants for each word
  const child = {
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        damping: 12,
        stiffness: 100
      }
    },
    hidden: {
      opacity: 0,
      y: 20,
      transition: {
        type: 'spring',
        damping: 12,
        stiffness: 100
      }
    }
  };
  return <Component className={className} data-id="element-65">
      <motion.div style={{
      overflow: 'hidden',
      display: 'flex',
      flexWrap: 'wrap'
    }} variants={container} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-50px'
    }} data-id="element-66">
        {words.map((word, index) => <motion.span key={index} className="mr-1 inline-block" variants={child} data-id="element-67">
            {word}
          </motion.span>)}
      </motion.div>
    </Component>;
}